<div class="wrapper">
  <div class="description">
    {{ description }}
  </div>
  <app-usage-bar
    class="usage-bar quantity-usage"
    heading="QUANTITY"
    [percent]="quantityUsedPercent"
    [label]="quantityUsedLabel"
    />
  @if (data.comment) {
    <section
      class="section">
      <div class="section-heading">DESCRIPTION:</div>
      <div class="section-content">{{data.comment}}</div>
    </section>
  }
  <section class="block section">
    @if (headingDetails) {
      <div
        class="block-heading"
        >
        {{ headingDetails?.name }}
      </div>
    }
    @if (sectionsList.length) {
      <section class="each-bid-item">
        @for (section of sectionsList; track section) {
          <mat-expansion-panel
            hideToggle
            [(expanded)]="section.isExpanded"
            class="station-section"
            (opened)="section.isExpanded = true"
            (closed)="section.isExpanded = false"
            id="{{section.id}}"
            >
            <mat-expansion-panel-header
              class="accordion-header"
              >
              <mat-panel-title class="station-heading">
                <div>{{section.heading}}</div>
                <mat-icon
                  class="chevron-icon"
                  [svgIcon]="section.isExpanded ? 'chevron-up' : 'chevron-down'"
                  />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="section-content">
              @if (section.isStartOfWork) {
                <div
                  class="start-location"
                  >
                  <mat-icon svgIcon="flag"/>
                  <div>Starting station</div>
                </div>
              }
              <section class="values-section">
                @if (!data.bid_item.record_by_station) {
                  <app-view-field
                    class="value-field"
                    label="QUANTITY"
                    [value]="data.quantity"
                    hint=""
                    [uom]="data.bid_item?.uom"
                    />
                }
                @for (field of section.fields; track field) {
                  <app-view-field
                    class="value-field"
                    [label]="field.label"
                    [value]="field.value"
                    [hint]="field.hint"
                    [uom]="field.uom"
                    />
                }
              </section>
              @if (section.comment) {
                <section
                  class="section">
                  <div class="section-heading">DESCRIPTION:</div>
                  <div class="section-content">{{section.comment}}</div>
                </section>
              }
              @if (section.pictures?.length) {
                <section
                  class="section">
                  <app-attachments-block
                    [pictures]="section.pictures"
                    />
                </section>
              }
            </div>
          </mat-expansion-panel>
        }
        @if (data.comment) {
          <section
            class="section description-section">
            <div class="section-heading">DESCRIPTION:</div>
            <div class="section-content">{{data.comment}}</div>
          </section>
        }
        @if (data.pictures?.length) {
          <section
            class="section">
            <app-attachments-block
              [pictures]="data.pictures"
              />
          </section>
        }
      </section>
    }
    @if (!sectionsList.length) {
      <section class="section">
        <section class="values-section">
          <app-view-field
            class="value-field"
            label="QUANTITY"
            [value]="data.quantity || 0"
            hint=""
            [uom]="data.bid_item?.uom"
            />
          @for (field of fieldsList; track field) {
            <app-view-field
              class="value-field"
              [label]="field.label"
              [value]="field.value"
              [hint]="field.hint"
              [uom]="field.uom"
              />
          }
        </section>
        @if (data.pictures?.length) {
          <section
            class="section">
            <app-attachments-block
              [pictures]="data.pictures"
              />
          </section>
        }
      </section>
    }
  </section>
</div>
